<template>
    <AnagraficaCrud titolo="Articoli (legni, vetri, pannelli)" endpoint="articoli" nuovo-label="Nuovo articolo"
        :colonne="colonne" :campi="campi" :filtri="filtri" :puo-scrivere="puoScrivere"
        colonne-import="CodArticolo, Descrizione, Categoria (o CodCategoria/CodMateriale: LEGNO, VETRO, PANNELLO), TipoLegno, UgVetro, UpPannello, DistanziatoreVetro, UpDistVetro, UpDistPannello, FattoreSolareVetro, TrasmisLuminosaVetro, DecibelAcustica, DecibelPannello, SpessoreVetro" />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

export default {
    name: "ArticoliPage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Codice", key: "codArticolo" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Categoria", key: "categoria" },
                { title: "Tipo legno", key: "tipoLegno" },
                { title: "Ug vetro", key: "ugVetro" },
                { title: "Up pannello", key: "upPannello" },
                { title: "Distanziatore", key: "distanziatoreVetro" },
                { title: "Ψ distanziatore", key: "upDistVetro" },
            ],
            campi: [
                { key: "codArticolo", label: "Codice articolo", tipo: "text", required: true },
                { key: "categoria", label: "Categoria", tipo: "select", items: ["LEGNO", "VETRO", "PANNELLO"], required: true },
                { key: "descrizione", label: "Descrizione", tipo: "text", cols: 12 },
                { key: "tipoLegno", label: "Tipo legno (solo legni)", tipo: "select", items: ["SuperTenero", "Tenero", "Duro", "ExtraDuro"] },
                { key: "distanziatoreVetro", label: "Distanziatore vetro", tipo: "select", items: ["BordoCaldo", "Standard"], hint: "Se vuoto vale Ψ distanziatore" },
                { key: "ugVetro", label: "Ug vetro (W/m²K)", tipo: "number" },
                { key: "upPannello", label: "Up pannello (W/m²K)", tipo: "number" },
                { key: "upDistVetro", label: "Ψ distanziatore vetro (W/mK)", tipo: "number" },
                { key: "upDistPannello", label: "Ψ distanziatore pannello (W/mK)", tipo: "number" },
                { key: "fattoreSolareVetro", label: "Fattore solare vetro", tipo: "number" },
                { key: "trasmisLuminosaVetro", label: "Trasmissione luminosa vetro", tipo: "number" },
                { key: "decibelAcustica", label: "Rw vetro (dB)", tipo: "number" },
                { key: "decibelPannello", label: "Rw pannello (dB)", tipo: "number" },
                { key: "spessoreVetro", label: "Spessore vetro (mm)", tipo: "number" },
            ],
            filtri: [{ key: "categoria", label: "Categoria", items: ["LEGNO", "VETRO", "PANNELLO"] }],
        };
    },

    computed: {
        puoScrivere() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },
    },
};
</script>
